module.exports = __webpack_public_path__ + "img/dress8.b7b813d6.jpeg";